import { fork, all } from 'redux-saga/effects';

import signIn from './auth/signIn';
import manager from './auth/manager';

import menu from './common/menu';
import code from './common/code';
import systemSetting from './common/systemSetting';
import scorecard from './common/scorecard';
import shopNotification from './common/shopNotification';
import itemNotification from './common/itemNotification';

import shopInfo from './shop/shopInfo';
import shopManagerInfo from './shop/shopManagerInfo';
import shopGameRoundOptionSetting from './shop/shopGameRoundOptionSetting';
import shopDrivingRangeOptionSetting from './shop/shopDrivingRangeOptionSetting';
import shopClientRealTimeControlOptionSetting from './shop/shopClientRealTimeControlOptionSetting';
import shopClientInfo from './shop/shopClientInfo';

import gameHistoryList from './gameHistory/list';

import clientStatusList from './clientStatus/list';
import clientStatusInfo from './clientStatus/info';

import paymentInfo from './billing/paymentInfo';
import recurringPayment from './billing/recurringPayment';
import payment from './billing/payment';
import bills from './billing/bills';
import itemPayment from './billing/itemPayment';

import notice from './customerService/notice';
import qna from './customerService/qna';

import tournamentList from './tournament/list';
import tournamentOpen from './tournament/open';
import tournamentDetails from './tournament/details';

import inventory from './inventory/list';
import itemShop from './itemShop/list';

// import shopNotify from './common/shopNotify';
// import dashboard from './home/dashboard';
// import gameHistory from './home/gameHistory';
// import clientStatus from './home/clientStatus';
// import shop from './home/shop';
// import scorecard from './home/scorecard';

export function* watchSagas() {
    yield all([
        fork(signIn),
        fork(manager),

        fork(menu),
        fork(code),
        fork(systemSetting),
        fork(scorecard),
        fork(shopNotification),
        fork(itemNotification),

        fork(shopInfo),
        fork(shopManagerInfo),
        fork(shopGameRoundOptionSetting),
        fork(shopDrivingRangeOptionSetting),
        fork(shopClientRealTimeControlOptionSetting),
        fork(shopClientInfo),

        fork(gameHistoryList),

        fork(clientStatusList),
        fork(clientStatusInfo),

        fork(paymentInfo),
        fork(recurringPayment),
        fork(payment),
        fork(bills),
        fork(itemPayment),

        fork(notice),
        fork(qna),

        fork(tournamentList),
        fork(tournamentOpen),
        fork(tournamentDetails),

        fork(inventory),
        fork(itemShop),

        // fork(shopNotify),
        // fork(dashboard),
        // fork(gameHistory),
        // fork(clientStatus),
        // fork(shop),
        // fork(scorecard),
    ]);
}
